const log = {
    code_id: null,
    microservice_id: 8,
    user_id: null,
    text: null,
};

export default log;
